import { render, staticRenderFns } from "./MercadoPagoOauth.vue?vue&type=template&id=05aa33f0&scoped=true"
import script from "./MercadoPagoOauth.vue?vue&type=script&lang=js"
export * from "./MercadoPagoOauth.vue?vue&type=script&lang=js"
import style0 from "./MercadoPagoOauth.vue?vue&type=style&index=0&id=05aa33f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05aa33f0",
  null
  
)

export default component.exports